import type { KpiResponse } from 'walden-fast/types/fast-backend/kpi';
import type { Factory } from 'walden-fast/types/mocks';

export const MOCK_KPIS: KpiResponse = {
  kpIs: [
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Second KPI',
      tileOrder: 2,
      trend: 'Increase|YoY',
      trendPercentage: 0.45,
      unit: 'Shipments',
      usedInReport: 'Dashboard',
      value: 1200,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Third KPI',
      tileOrder: 3,
      trend: 'Decrease|MoM',
      trendPercentage: 0.45,
      unit: 'Shipments',
      usedInReport: 'Dashboard',
      value: 1201,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'First KPI',
      tileOrder: 1,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Shipments',
      usedInReport: 'Dashboard',
      value: 1202,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Some KPI',
      tileOrder: 1,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Shipments',
      usedInReport: 'Inventory',
      value: 1200,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Inbound Shipments',
      tileOrder: 1,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Shipments',
      usedInReport: 'Inbound & Outbound',
      value: 1200,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Outbound Shipments',
      tileOrder: 2,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Shipments',
      usedInReport: 'Inbound & Outbound',
      value: 1100,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Inbound Delivery Time',
      tileOrder: 3,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'Hours',
      usedInReport: 'Inbound & Outbound',
      value: 480,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Outbound Delivery Time',
      tileOrder: 4,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Hours',
      usedInReport: 'Inbound & Outbound',
      value: 450,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Total Shipments',
      tileOrder: 5,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Shipments',
      usedInReport: 'Inbound & Outbound',
      value: 2300,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Total Orders Processed',
      tileOrder: 1,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Orders',
      usedInReport: 'Order Details',
      value: 5000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Order Accuracy',
      tileOrder: 2,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Order Details',
      value: 980,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Average Order Value',
      tileOrder: 3,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'USD',
      usedInReport: 'Order Details',
      value: 1500,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Order Return Rate',
      tileOrder: 4,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Order Details',
      value: 30,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Order Processing Time',
      tileOrder: 5,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'Hours',
      usedInReport: 'Order Details',
      value: 240,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Data Accuracy',
      tileOrder: 1,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Master Data',
      value: 990,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Data Completeness',
      tileOrder: 2,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Master Data',
      value: 950,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Data Latency',
      tileOrder: 3,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Minutes',
      usedInReport: 'Master Data',
      value: 100,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Master Data Requests',
      tileOrder: 4,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Requests',
      usedInReport: 'Master Data',
      value: 15000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Data Quality Score',
      tileOrder: 5,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Score',
      usedInReport: 'Master Data',
      value: 45,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Transport Cost',
      tileOrder: 1,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'USD',
      usedInReport: 'Transport',
      value: 200000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Transport Efficiency',
      tileOrder: 2,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Transport',
      value: 880,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'On-time Deliveries',
      tileOrder: 3,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Transport',
      value: 950,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Transport Delays',
      tileOrder: 4,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Minutes',
      usedInReport: 'Transport',
      value: 150,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Fuel Consumption',
      tileOrder: 5,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'Liters',
      usedInReport: 'Transport',
      value: 50000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Order Tracking Accuracy',
      tileOrder: 1,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Order Tracking',
      value: 970,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Order Tracking Updates',
      tileOrder: 2,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Updates',
      usedInReport: 'Order Tracking',
      value: 12000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Real-time Tracking Availability',
      tileOrder: 3,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Order Tracking',
      value: 990,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Tracking System Downtime',
      tileOrder: 4,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Minutes',
      usedInReport: 'Order Tracking',
      value: 300,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Tracking Error Rate',
      tileOrder: 5,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Order Tracking',
      value: 20,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Cash Collection Efficiency',
      tileOrder: 1,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Order 2 Cash',
      value: 930,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Average Invoice Processing Time',
      tileOrder: 2,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Days',
      usedInReport: 'Order 2 Cash',
      value: 50,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Accounts Receivable Aging',
      tileOrder: 3,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'Days',
      usedInReport: 'Order 2 Cash',
      value: 300,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Bad Debt Ratio',
      tileOrder: 4,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Order 2 Cash',
      value: 10,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Cash Flow Turnover',
      tileOrder: 5,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Times',
      usedInReport: 'Order 2 Cash',
      value: 40,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Carbon Offset Achieved',
      tileOrder: 1,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Tonnes',
      usedInReport: 'Walden Green',
      value: 20000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Renewable Energy Usage',
      tileOrder: 2,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Green',
      value: 500,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Waste Reduction',
      tileOrder: 3,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Green',
      value: 150,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Green Transportation Usage',
      tileOrder: 4,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Green',
      value: 300,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Energy Efficiency',
      tileOrder: 5,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Green',
      value: 900,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Forecast Accuracy',
      tileOrder: 1,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden ML',
      value: 920,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Cash Flow Prediction',
      tileOrder: 2,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'USD',
      usedInReport: 'Walden ML',
      value: 500000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Forecasted Revenue Growth',
      tileOrder: 3,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden ML',
      value: 80,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Accuracy of Cost Predictions',
      tileOrder: 4,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden ML',
      value: 890,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Cash Flow Variance',
      tileOrder: 5,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'USD',
      usedInReport: 'Walden ML',
      value: 10000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Server Uptime',
      tileOrder: 1,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Orchestration',
      value: 999,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'System Latency',
      tileOrder: 2,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'Milliseconds',
      usedInReport: 'Walden Orchestration',
      value: 2000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'System Errors',
      tileOrder: 3,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Errors',
      usedInReport: 'Walden Orchestration',
      value: 50,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Server Load',
      tileOrder: 4,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Orchestration',
      value: 750,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Event Processing Time',
      tileOrder: 5,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'Milliseconds',
      usedInReport: 'Walden Orchestration',
      value: 1000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Total Orders Processed',
      tileOrder: 1,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: 'Orders',
      usedInReport: 'Walden Box',
      value: 12000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Order Fulfillment Time',
      tileOrder: 2,
      trend: 'Decrease|WoW',
      trendPercentage: 0.45,
      unit: 'Hours',
      usedInReport: 'Walden Box',
      value: 240,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Orders Returned',
      tileOrder: 3,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Box',
      value: 30,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Orders Delivered On Time',
      tileOrder: 4,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Box',
      value: 950,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Order Satisfaction',
      tileOrder: 5,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Box',
      value: 900,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Service Uptime',
      tileOrder: 1,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Connect',
      value: 999,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Service Performance',
      tileOrder: 2,
      trend: 'Increase|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Connect',
      value: 920,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Support Tickets Resolved',
      tileOrder: 3,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Tickets',
      usedInReport: 'Walden Connect',
      value: 10000,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Customer Satisfaction',
      tileOrder: 4,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: '%',
      usedInReport: 'Walden Connect',
      value: 850,
    },
    {
      clientNameMaster: 'DEMO',
      kpiName: 'Service Response Time',
      tileOrder: 5,
      trend: 'Stable|WoW',
      trendPercentage: 0.45,
      unit: 'Minutes',
      usedInReport: 'Walden Connect',
      value: 150,
    },
  ],
};

export const kpiResponseFactory: Factory<KpiResponse> = (overrides) => ({
  ...MOCK_KPIS,
  ...overrides,
});
